import { z } from 'zod';
/**
 * Machine-readable error codes. The client maps these to copy in `messages`; the code itself is
 * never shown to a grower.
 */
export const apiErrorCodeSchema = z.enum([
    'validation_failed',
    'invalid_credentials',
    'unauthorised',
    'forbidden',
    'not_found',
    'conflict',
    'edit_window_closed',
    'rate_limited',
    'internal',
]);
export const apiErrorSchema = z.object({
    error: z.object({
        code: apiErrorCodeSchema,
        /** Developer-facing detail. Logged, not displayed. */
        message: z.string(),
        /** Field paths for `validation_failed`, so forms can mark the right input. */
        fields: z.record(z.string(), z.string()).optional(),
    }),
});
export const healthResponseSchema = z.object({ ok: z.literal(true) });
//# sourceMappingURL=api.js.map